<p>download-app-android-click works!</p>
